import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Avatar from '../icons/Avatar';
import ProfileDropdown from './ProfileDropdown';
import { useAuth } from '../../contexts/AuthContext';
import { useModal } from '../../contexts/ModalContext';
import HamburgerIcon from '../icons/HamburgerIcon';

interface TopBarProps {
  onMenuToggle: () => void;
}

export default function TopBar({ onMenuToggle }: TopBarProps) {
    const { isLoggedIn } = useAuth();
    const { openLoginModal } = useModal();
    const [isProfileOpen, setIsProfileOpen] = useState(false);

    return (
        <div className="fixed top-0 left-0 right-0 h-16 bg-white border-b border-gray-200 flex items-center justify-between px-4 z-[1001]">
            {/* Left: Hamburger (narrow) + Logo */}
            <div className="flex items-center gap-3 xl:w-[240px] xl:ml-4">
                <button
                    onClick={onMenuToggle}
                    className="xl:hidden flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 transition-colors"
                    aria-label="Toggle navigation menu"
                >
                    <HamburgerIcon width={22} height={22} color="#333" />
                </button>
                <Link to="/" className="hidden md:block text-2xl font-bold text-black no-underline">
                    CourseMap
                </Link>
            </div>

            {/* Right: Profile/Auth */}
            <div className="flex items-center justify-end xl:w-[240px] gap-4">
                {isLoggedIn ? (
                    <div className="relative">
                        <button 
                            onClick={() => setIsProfileOpen(!isProfileOpen)}
                            className="bg-gray-100 hover:bg-gray-200 cursor-pointer w-[40px] h-[40px] rounded-full flex items-center justify-center transition-colors"
                            aria-label="Profile menu"
                        >
                            <Avatar className="w-[24px] h-[24px] text-gray-700" />
                        </button>
                        
                        <div className="absolute right-0 top-[calc(100%+0.5rem)] z-[1002]">
                            <ProfileDropdown 
                                isOpen={isProfileOpen}
                                onClose={() => setIsProfileOpen(false)}
                            />
                        </div>
                    </div>
                ) : (
                    <button
                        onClick={openLoginModal}
                        className="px-4 py-2 bg-[#2563eb] text-white text-sm font-medium rounded-full hover:bg-[#1d4ed8] transition-colors"
                    >
                        Sign In
                    </button>
                )}
            </div>
        </div>
    );
}
